// NPM packages
import React from 'react';
import { Typography } from '@mui/material';
import styled from '@emotion/styled';

// All other imports
import H1 from 'components/core/H1';
import Link from 'components/core/Link';

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '60vh',
  width: '100%',
  padding: '2rem',
});

const ContentBox = styled.div({
  textAlign: 'left',
  maxWidth: 480,
  width: '100%',
});

const EmailHelpLink = styled(Link)(({ theme: { typography } }) => ({
  fontWeight: typography.fontWeightBold,
}));

export interface NotFoundContentProps {
  className?: string;
}

export default function NotFoundContent(
  props: NotFoundContentProps
): React.ReactElement | null {
  const { className } = props;
  return (
    <Root className={className}>
      <ContentBox>
        <H1 style={{ textAlign: 'center' }}>Page Not Found</H1>
      </ContentBox>
        <Typography>
          Please shoot us an email at{' '}
          <EmailHelpLink to="mailto:info@msdlive.org">info@msdlive.org</EmailHelpLink>{' '}
          if this doesn't seem right.
        </Typography>
    </Root>
  );
}
